export default {
  //Greek el(languagecode) GR(countrycode) Ελλάδα / Ελληνικά
  LandingPage: {
    intro_sub:
      'Δώστε νέα ζωή στα απορρίμματα συσκευασίας και συμμετάσχετε στην προστασία του περιβάλλοντος.',
    title: 'Συσκευασία Upcycle Samsung',
    sequence1_1: 'Συμμετάσχετε στις ενέργειές μας για τη μείωση των απορριμμάτων',
    sequence1_2:
      'για βιώσιμη ανάπτυξη μετατρέποντας τη συσκευασία της τηλεόρασής σας σε χρήσιμα είδη. Περιηγηθείτε προς τα κάτω για να κάνετε το πρώτο βήμα.',
    sequence2_1: 'Παρουσιάζουμε το Upcycle-Packaging της Samsung',
    sequence2_2:
      'Μια συσκευασία τηλεόρασης που έχει σχεδιαστεί για να επαναχρησιμοποιηθεί. Δημιουργήστε διάφορα είδη για το σπίτι με τη συσκευασία της τηλεόρασής σας.',
    sequence3_1: 'Ακολουθήστε τις τυπωμένες κουκκίδες στη συσκευασία',
    sequence3_2:
      'Κόψτε τη συσκευασία σύμφωνα με τις οδηγίες και συναρμολογήστε τη για να δημιουργήσετε μια ενδιαφέρουσα κατασκευή.',
    sequence4_1: 'Επιλέξτε το αντικείμενο που θέλετε να δημιουργήσετε',
    sequence4_2:
      'Περιηγηθείτε παρακάτω και επιλέξτε το μοντέλο τηλεόρασης που έχετε στη συσκευασία σας. Στη συνέχεια, βρείτε διάφορες επιλογές σχεδίων για εσάς. Τώρα, ξεκινήστε το ταξίδι σας με το αντικείμενο που επιθυμείτε να δημιουργήσετε.',
    selectBox: 'Επιλέξτε την τηλεόρασή σας',
    moreActivity:
      "Για περισσότερες πληροφορίες σχετικά με τις βιώσιμες δραστηριότητες της Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/gr/sustainability/overview/',
    //moreActivityLink:'https://www.samsung.com/gr/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/gr/sustainability/overview/',
    footer: `
    Copyright© 2019-2021 Samsung. Με την επιφύλαξη παντός δικαιώματος.`,
  },
  ProductPage: {
    selectDesign: 'Επιλέξτε σχέδιο για να δημιουργήσετε',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Έπιπλο τηλεόρασης',
    StorageBox: 'Αποθηκευτικός χώρος',
    MagazineRack: 'Θήκη για περιοδικά',
    CatHouse: 'Σπίτι για τη γάτα',
    CatTunnel: 'Τούνελ/παιχνίδι για τη γάτα',
    BookShelf: 'Ράφι για βιβλία',
    DeskShelf: 'Ράφι γραφείου',
    BlackRhino: 'Μαύρος Ρινόκερος', //update
    PolarBear: 'Πολική Αρκούδα', //update
    SeaTurtle: 'Θαλάσσια Χελώνα', //update
    TheRider: 'Ο Αναβάτης', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Τραπεζάκι \n Μπράτσου Καναπέ', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Τραπέζι Kinoko', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Θήκη για κάρτες', //update
    SneakerRack: 'Ράφι \n παπουτσιών', //update
    TheSoban: 'Τραπεζάκι τύπου Soban', //update
    ToolBox: 'Εργαλειοθήκη', //update
    DeskStationary: 'Θήκη για χαρτικά',
    CoinBank: 'Θήκη νομισμάτων',
    MobileScanner:'Βάση smartphone',
    TabletScanner:'Βάση tablet',
    PetStairs:'Κατοικίδια σκάλες',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'λεπτά',
    all:'ΟΛΑ',
    in: 'σε',
    inOnly: 'σε μόνο',
    allBoxSize: 'Όλα τα μεγέθη συσκευασίας',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'οδηγίες',
    prepare: 'Προετοιμασία της συσκευασίας',
    LetsDesign: "Ας σχεδιάσουμε",
    drawParts: 'Ζωγραφίστε μέρη του κουτιού',
    note1: 'Έχετε υπόψη σας ότι η θέση των γραφικών μπορεί να διαφέρει ανά χώρα και μέγεθος',
    note2: 'Σχεδιάστε όλο το σχέδιο πρώτα έτσι ώστε να ταιριάζει στο κουτί',
    numberSpace: 'αριθμός = χώροι μεταξύ των κουκκίδων',
    diagonal: 'Διαγώνιος',
    LEFT: 'ΑΡΙΣΤΕΡΟ (κομμάτι)',
    RIGHT: 'ΔΕΞΙΟ (κομμάτι)',
    TOP: 'ΕΠΑΝΩ (κομμάτι)',
    TOP1: 'ΕΠΑΝΩ (κομμάτι) 1',
    TOP2: 'ΕΠΑΝΩ (κομμάτι) 2',
    BACK: 'ΠΙΣΩ (κομμάτι)',
    MIDDLE: 'ΜΕΣΑΙΟ (κομμάτι)',
    MIDDLE2: 'ΜΕΣΑΙΟ (κομμάτι) 2',
    BOTTOM: 'ΚΑΤΩ (κομμάτι)',
    FRONT: 'ΜΠΡΟΣΤΙΝΟ (κομμάτι)',
    SIDE: 'ΠΛΑΪΝΟ (κομμάτι)',
    secondSIDE: 'ΔΕΥΤΕΡΗ ΠΛΕΥΡΑ (κομμάτι)',
    secondSIDE1: 'ΔΕΥΤΕΡΗ ΠΛΕΥΡΑ (κομμάτι) 1',
    secondSIDE2: 'ΔΕΥΤΕΡΗ ΠΛΕΥΡΑ (κομμάτι) 2',
    LEG: 'ΠΟΔΙ (κομμάτι)', //update
    JOINT: 'ΣΥΝΔΕΣΜΟΣ (κομμάτι)', //update
    FACE: 'ΠΡΟΣΩΠΟ (κομμάτι)', //update
    DRAWERBOTTOM: 'ΚΑΤΩ ΣΥΡΤΑΡΙ (κομμάτι', //update
    DRAWERSIDE: 'ΠΛΑΪΝΟ ΣΥΡΤΑΡΙ (κομμάτι)', //update
    NOSE: 'MYTH (κομμάτι)', //update
    HANDLE: 'ΛΑΒΗ (κομμάτι)', //update
    BOTTOMSIDE: 'ΚΑΤΩ ΠΛΕΥΡΑ (κομμάτι)', //update
    TOPSIDE: 'ΕΠΑΝΩ ΠΛΕΥΡΑ (κομμάτι)', //update
    WING: 'ΦΤΕΡΟ (κομμάτι)', //update
    cutAndAssemble: "Ας κόψουμε και ας συναρμολογήσουμε",
    beCareful: 'Να είστε προσεκτικοί για να μην κοπείτε με το κοπίδι',
    cutOutParts: 'Κόψτε τα μέρη',
    assemble: 'Συναρμολογήστε',
    Assemblyguide: 'Οδηγός συναρμολόγησης', //update
    fold: 'Παράδειγμα διπλώματος',
    foldGuide: 'Χρησιμοποιήστε την άκρη των επίπλων κατά το δίπλωμα του χαρτονιού',
    foldGuideDezeen:
      'Πιέστε τη διάστικτη γραμμή του χαρτονιού με κάποιο εργαλείο μερικές φορές για να βοηθήσετε τη δίπλωση του χαρτονιού', //update
    glue: 'Χρησιμοποιήστε κόλλα ή ταινία ομοιόμορφα στην επιφάνεια', //update
    cable: 'Χρησιμοποιήστε πιαστράκια ή σπάγκο για τη σύνδεση', //update
    done: 'Έτοιμο!',
    goBack: 'Επιστρέψτε στο βασικό μενού',
  },
  CautionPage: {
    CAUTION: 'ΠΡΟΣΟΧΗ',
    needItem: 'Θα χρειαστείτε αυτά τα αντικείμενα',
    children: 'Τα παιδιά πρέπει να επιβλέπονται από ενήλικες',
    mat:
      'Τοποθετήστε ένα κάλυμμα στο δάπεδο για να αποφύγετε τις εκδορές κατά τη διαδικασία',
    doNotPutHeavyThing:
      'Μην περπατάτε ή κάθεστε πάνω σε αυτά τα έπιπλα και προσπαθήστε να ΜΗΝ τοποθετείτε βαριά αντικείμενα επάνω τους',
    doNotThrow:
      'Μην πετάτε ή κλοτσάτε τα έπιπλα',
    stayAwayFlame: 'Μείνετε μακριά από εστία φωτιάς',
    stayAwayWater: 'Μην τοποθετείτε κοντά σε νερό ή υγρασία',
    mayDamaged: '* Η συσκευασία της τηλεόρασης ενδέχεται να υποστεί φθορές κατά τη διαδικασία της αποστολής',
    companyDoestResponsible:
      '* Η Samsung δεν έχει καμία ευθύνη για βλάβες ή τραυματισμούς κατά της διάρκεια αυτής της εργασίας',
    cannotBeReturned:
      '* Το προϊόν δεν μπορεί να επιστραφεί ως ελαττωματικό επειδή η συσκευασία φέρει φθορές ',
    understand: 'Εντάξει, το κατάλαβα',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Χρησιμοποιήσαμε λιγότερο χαρτί και μελάνι για τις περισσότερες συσκευασίες τηλεοράσεων σε σύγκριση με τις προηγούμενες συσκευασίες μας υλοποιώντας τη δέσμευσή μας για βιωσιμότητα',
      text2:'',
      text2_special:
        '(* Το παραπάνω δεν ισχύει για ορισμένα μοντέλα όπως τηλεοράσεις Lifestyle)',
      text3: 'Δείτε τις παρακάτω επιλογές για να ανακαλύψετε περισσότερα',
    },
    greenIn: {
      title: 'Going Green στις συσκευασίες τηλεόρασης',
      subtitle1: 'Αναζήτηση για Στοιχεία Προϊόντος',
      subtitle2: 'Επαναχρησιμοποίηση της συσκευασίας',
      desc: 'Αναζήτηση ονόματος μοντέλου για περισσότερες πληροφορίες',
      descM: '*Πάρτε μια φωτογραφία του αριθμού μοντέλου της τηλεόρασης',
      guide: 'όνομα μοντέλου',
      button: 'Λήψη φωτογραφίας',
      button2: 'Μετάβαση στη δημιουργία αντικειμένων',
      product_info: 'Πληροφορίες Προϊόντος',
    },
    search: {
      guide: 'Αναζήτηση..',
      noResult: 'Κανένα αποτέλεσμα',
      more: 'ΠΕΡΙΣΣΟΤΕΡΑ',
      search: 'Αναζήτηση',
      retake: 'Επανάληψη λήψης',
      result: 'Αποτέλεσμα',
    },
    photo: {
      guide1: 'Τοποθετήστε το όνομα του μοντέλου της τηλεόρασης στη συσκευασία',
      guide2: '(πχ. Q800A, UT7072, RU7102, κ.τ.λ.)',
    },
  },
  searchCountrySelect: 'Επιλέξτε χώρα για αναζήτηση'
};
